import { createAsyncThunk } from "@reduxjs/toolkit";
import { PresentationService } from "@root/services";
import { prepareErrorResponse } from "@root/services/http/response";
import { getBaseUrl } from "@root/store/selectors/features";
import {
  CREATE_PRESENTATION,
  GET_TEMPLATES,
} from "../action-types/presentation";

const presentationService = new PresentationService();

export const createPresentation: any = createAsyncThunk(
  CREATE_PRESENTATION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, payload } = requestPayload;
    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const result = await presentationService.createPresentation(
        baseUrl,
        payload
      );
      onSuccess(result?.data?.data, CREATE_PRESENTATION);
      return thunkAPI.fulfillWithValue(result?.data?.data);
    } catch (error) {
      onError(error, CREATE_PRESENTATION);
      const customError = prepareErrorResponse(error);
      return thunkAPI.rejectWithValue(customError);
    }
  }
);

export const getTemplates: any = createAsyncThunk(
  GET_TEMPLATES,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError } = requestPayload;
    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const result = await presentationService.getThemes(baseUrl);
      onSuccess(result?.data?.data, GET_TEMPLATES);
      return thunkAPI.fulfillWithValue(result?.data?.data);
    } catch (error) {
      onError(error, GET_TEMPLATES);
      const customError = prepareErrorResponse(error);
      return thunkAPI.rejectWithValue(customError);
    }
  }
);
